import map from 'lodash/map';
import orderBy from 'lodash/orderBy';

const files = require.context('.', false, /\.js$/);
const messages = {};

files.keys().forEach(key => {
	if (key === './index.js') return;
	messages[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

const locales = orderBy(
	map(Object.keys(messages), locale_code => ({
		code: locale_code,
		name: messages[locale_code].locale_name,
		order: messages[locale_code].locale_order,
	})),
	['order'],
);

export { locales };
